import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function get<T, R = undefined>(
    obj: T,
    path: string,
    defaultValue?: R,
): R | unknown {
    if (obj == null) return defaultValue;
    const keys = path.split(".");
    let result: unknown = obj;
    for (const key of keys) {
        if (result !== null && typeof result === "object" && key in result) {
            result = (result as Record<string, unknown>)[key];
        } else {
            return defaultValue;
        }
    }
    return result === undefined ? defaultValue : result;
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
